import { types } from 'mobx-state-tree';
import { RELATION_TYPE } from '../components/DeclarativeForm/constants';

export default types.model('relationField', {
  type: types.maybe(types.enumeration([RELATION_TYPE.MANY, RELATION_TYPE.ONE])),
  modelId: types.maybe(types.string)
});
